export default "__VITE_ASSET__DmPq$Zw4__"